// App
export const SET_TOUCH_DEVICE = 'SET_TOUCH_DEVICE'
export const SET_MOUSE_POSITION = 'SET_MOUSE_POSITION'
export const SET_MOUSE_IN_WINDOW = 'SET_MOUSE_IN_WINDOW'
export const SET_CLIENT_DIMENSIONS = 'SET_CLIENT_DIMENSIONS'
export const SET_TIMER = 'SET_TIMER'
export const SET_ABOUT_DISPLAY = 'SET_ABOUT_DISPLAY'
export const SET_LOADED = 'SET_LOADED'

// Slider
export const ADD_PROJECT = 'ADD_PROJECT'
export const SET_INDEX = 'SET_INDEX'
export const SET_NEXT_INDEX = 'SET_NEXT_INDEX'
export const SET_PREV_INDEX = 'SET_PREV_INDEX'
export const SET_TOGGLE_HOVER = 'SET_TOGGLE_HOVER'
export const SET_DIRECTION = 'SET_DIRECTION'
export const SET_REQUEST_NEXT_SLIDE = 'SET_REQUEST_NEXT_SLIDE'



// WEBPACK FOOTER //
// ./src/store/mutationsTypes/MutationsTypes.js